.headerBar {
  background: white;
  transition: all 0.5s;
  z-index: 997;
  padding: 20px 0;
}

.headerBarHeaderScrolled {
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
  padding: 12px 0;
}

.headerBar .logo {
  font-size: 28px;
  margin: 0;
  padding: 0;
  line-height: 1;
  font-weight: 700;
  text-transform: uppercase;
}

.headerBar .logo a {
  color: #556270;
}

.headerBar .logo img {
  max-height: 40px;
}
